import { memo } from 'react';
import styled from 'styled-components';
import { SPACING_SCALING_FACTOR as GAP_BETWEEN_CHIPS } from '../../../constants';
import { getSelectText } from '../helper-functions/getSelectText';
import Chip from './chip';

interface IChips {
  selectValue: string[];
  optionsMap: Record<string, string>;
  handleRemoveSelectValue: (value: string) => void;
  closeButtonLabel?: string;
  disabled?: boolean;
}

const ChipsInManyRows = ({
  selectValue,
  optionsMap,
  handleRemoveSelectValue,
  closeButtonLabel,
  disabled = false,
}: IChips) => {
  return (
    <ChipsWrapper>
      {selectValue.map((value) => {
        return (
          <Chip
            key={value}
            onClick={() => handleRemoveSelectValue(value)}
            text={getSelectText(value, optionsMap)}
            closeButtonLabel={closeButtonLabel}
            disabled={disabled}
          />
        );
      })}
    </ChipsWrapper>
  );
};

export default memo(ChipsInManyRows);

const ChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${GAP_BETWEEN_CHIPS}px;
  width: 100%;
  max-width: 100%;
  width: 100%;
`;
